import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarPriceGuideCard from "./component";
import withLogin from "../with-login";

const mapStateToProps = ({
    carDetails: {
        content
    }
}) => ({
    content
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withLogin(connect(mapStateToProps, mapDispatchToProps)(CarPriceGuideCard));
